import axios from './index';

class AuthApi {
  static Login = (data) => {
    let request = {
      username: data.email,
      password: data.password,
    };
    return axios.post(`${base}/admin/login`, request);
  };

  static verifyWithOTP = (data) => {
    return axios.post(`${base}/verifyotp`, data);
  };
  static LoginWithOtp = (data) => {
    return axios.post(`${base}/loginwithotp`, data);
  };
  static sendVerificationOtp = (data) => {
    return axios.post(`${base}/send-verification-otp`, data);
  };
  static SetPassword = (password, token) => {
    return axios.post(
      `${base}/set-password`,
      JSON.stringify({ password: password }),
      {
        headers: { setpasswordtoken: `${token}` },
      }
    );
  };
  static ResetPassword = (data) => {
    return axios.post(`${base}/reset-password`, data);
  };
  static UserData = (data) => {
    return axios.get(`${base}/userProfile`, {
      headers: { accessToken: `${data.token}` },
    });
  };
  static ResendOTP = (data) => {
    return axios.post(`${base}/resendotp`, data);
  };
  static RefreshToken = () => {
    console.log('I am in Refresh token api call');
    return axios.post(
      `${base}/refresh`,
      {},
      {
        headers: {
          refreshtoken: `${sessionStorage.getItem('refreshtoken')}`,
        },
      }
    );
  };
  static Profile = (data) => {
    let require = {
      name: data.name,
      email: data.email,
      phoneNumber: data.phoneNumber,
      pic: data.pic,
      city: data.city,
      detailsJSON: {
        dob: data.dob,
        exp: data.exp,
      },
      gender: data.gender,
      about: data.about,
    };
    return axios.patch(`${base}/userProfile`, require, {
      headers: { accessToken: `${data.token}` },
    });
  };
  static Logout = () => {
    return axios.post(`${base}/logout`);
  };
}

let base = 'auth';

export default AuthApi;
